import React from 'react';
import classNames from 'classnames';

var Loader = function Loader(_ref) {
  var textDescription = _ref.textDescription,
      _ref$negative = _ref.negative,
      negative = _ref$negative === void 0 ? false : _ref$negative,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      className = _ref.className,
      _ref$dataTestAutoId = _ref.dataTestAutoId,
      dataTestAutoId = _ref$dataTestAutoId === void 0 ? "jkl-loader" : _ref$dataTestAutoId,
      _ref$politeness = _ref.politeness,
      politeness = _ref$politeness === void 0 ? "polite" : _ref$politeness;
  var componentClassName = classNames("jkl-loader", className, {
    "jkl-loader--negative": negative,
    "jkl-loader--inline": inline
  });
  return /*#__PURE__*/React.createElement("span", {
    className: componentClassName,
    "data-testid": "jkl-loader",
    "data-testautoid": dataTestAutoId,
    title: textDescription,
    "aria-label": textDescription,
    role: "alert",
    "aria-busy": "true",
    "aria-live": politeness
  }, /*#__PURE__*/React.createElement("span", {
    className: "jkl-loader__dot jkl-loader__dot--left"
  }), /*#__PURE__*/React.createElement("span", {
    className: "jkl-loader__dot jkl-loader__dot--middle"
  }), /*#__PURE__*/React.createElement("span", {
    className: "jkl-loader__dot jkl-loader__dot--right"
  }));
};

export { Loader };
